import { render, staticRenderFns } from "./Init.vue?vue&type=template&id=1f0d326b&scoped=true&"
import script from "./Init.vue?vue&type=script&lang=js&"
export * from "./Init.vue?vue&type=script&lang=js&"
import style0 from "./Init.vue?vue&type=style&index=0&id=1f0d326b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0d326b",
  null
  
)

export default component.exports